/** Mimics C#'s nameof() operator to provide static type checking.  If the string value specified is not on the 
 * object, a compile-type error is raised. */
export const nameof = <T>(name: keyof T) => name;